import React, { useRef, useState } from 'react';

import { DynamicIconWrapper, Icons, Tooltip } from '@components/common';
import ActionMenu from '@components/routes/AdminPanel/ManageCrowdCells/LinkMenu/LinkActionList';

import { useOnClickOutsideSelect } from '@hooks/utils/useOnClickOutSide';

import { ILinkActionInterface } from '../interfaces';

import styles from './LinkMenu.module.scss';

interface ILinkMenuProps {
	actions: Array<ILinkActionInterface>;
	isLink?: boolean;
	selectHandler: () => void;
	tooltipContent: string;
}

const LinkMenu = ({
	actions,
	selectHandler,
	tooltipContent,
}: ILinkMenuProps) => {
	const menuRef = useRef<HTMLDivElement | null>(null);

	const [showMenu, setShowMenu] = useState(false);

	const toggleShowMenu = () => setShowMenu((prev) => !prev);

	const closeShowMenu = () => setShowMenu(false);

	useOnClickOutsideSelect([menuRef], () => showMenu && closeShowMenu());

	return (
		<Tooltip
			content={tooltipContent}
			maxWidth={325}
		>
			<div className={styles.linkMenu}>
				<div className={styles.icon}>
					<span onClick={toggleShowMenu}>
						<DynamicIconWrapper icon={Icons.link} />
					</span>
				</div>
				{showMenu && (
					<ActionMenu
						actions={actions}
						menuRef={menuRef}
						selectHandler={selectHandler}
					/>
				)}
			</div>
		</Tooltip>
	);
};

export default LinkMenu;
